const development_tenant = {
    notification: 'Você está no modo de desenvolvimento',
};
export default Object.freeze(development_tenant);
